import { render, staticRenderFns } from "./typography.vue?vue&type=template&id=4ff968c9&scoped=true&"
import script from "./typography.vue?vue&type=script&lang=js&"
export * from "./typography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff968c9",
  null
  
)

export default component.exports